import { render } from "./SalesList.vue?vue&type=template&id=747d6922&scoped=true&ts=true"
import script from "./SalesList.vue?vue&type=script&lang=ts"
export * from "./SalesList.vue?vue&type=script&lang=ts"

import "./SalesList.vue?vue&type=style&index=0&id=747d6922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747d6922"]])

export default __exports__